import lazyLoad from './utils/lazyLoad'

const BlankConfig = [
  {
    component: lazyLoad(() => import('./views/Discard')),
    path: '/blank/discard',
    exact: true,
  },
  {
    component: lazyLoad(() => import('./views/Document')),
    path: '/blank/document',
    exact: true,
  },
  {
    component: lazyLoad(() => import('./views/Policy')),
    path: '/blank/policy',
    exact: true,
  }
]
const NormalConfig = [
  {
    component: lazyLoad(() => import('./views/CertInfo')),
    path: '/normal/query/detail',
    exact: true,
  },
  {
    component: lazyLoad(() => import('./views/NewCertInfo')),
    path: '/normal/query/newdetail',
    exact: true,
  },
  {
    component: lazyLoad(() => import('./views/Query')),
    path: '/normal/query',
    exact: true,
  },
  {
    component: lazyLoad(() => import('./views/HashCheck')),
    path: '/normal/query/hashcheck',
    exact: true,
  }
]
const HomeConfig = [
  {
    component: lazyLoad(() => import('./views/Index')),
    path: '/home',
    exact: true,
  },
  {
    component: lazyLoad(() => import('./views/Ink')),
    path: '/home/ink',
    exact: true,
  },
  {
    component: lazyLoad(() => import('./views/CertInfo')),
    path: '/home/query',
    exact: true,
  },
  {
    component: lazyLoad(() => import('./views/Solution')),
    path: '/home/solution',
    routes: [
      {
        component: lazyLoad(() => import('./views/Art')),
        path: '/home/solution/art',
        exact: true,
      },
      {
        component: lazyLoad(() => import('./views/Medicine')),
        path: '/home/solution/medicine',
        exact: true,
      },
      {
        component: lazyLoad(() => import('./views/Cert')),
        path: '/home/solution/cert',
        exact: true,
      },
      {
        component: lazyLoad(() => import('./views/Copyright')),
        path: '/home/solution/copyright',
        exact: true,
      },
      {
        component: lazyLoad(() => import('./views/Contract')),
        path: '/home/solution/contract',
        exact: true,
      },
    ],
  }
]

export { HomeConfig, BlankConfig, NormalConfig }



// WEBPACK FOOTER //
// ./src/routes.ts